import React, { useState, useEffect } from "react";
import {
  Table, TableBody, TableCell, TableHead, TableRow, TableContainer,
  IconButton, Menu, MenuItem, Typography, Paper, CircularProgress, Box
} from "@material-ui/core";
import SettingsIcon from "@material-ui/icons/Settings";
import { toast } from "react-toastify";
import axios from "axios";
import { BACKEND_BASE_URL } from "../config";

const headerCellStyle = {
  fontWeight: "bold",
  backgroundColor: "#152F8F",
  color: "white",
  border: "1px solid #ddd",
  minWidth: 100,
  fontSize: "1rem",
  padding: "6px 12px",
};
const bodyCellStyle = {
  border: "1px solid #ddd",
  background: "#fff",
  fontSize: "0.95rem",
  padding: "4px 10px",
};

const ManageAwareCapture = () => {
  const [user, setUser] = useState(null);
  const [toggledTowns, setToggledTowns] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedTown, setSelectedTown] = useState(null);
  const [loading, setLoading] = useState(true); // ✅ Added loading state

  const fetchToggledTowns = async () => {
  try {
    setLoading(true); // Show spinner while loading
    const token = localStorage.getItem("authToken");
    const response = await axios.get(`${BACKEND_BASE_URL}/api/capture/capture-municipalities/`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    setToggledTowns(response.data.data || []);
  } catch (error) {
    toast.error("Failed to fetch toggled towns.");
    console.error(error);
  } finally {
    setLoading(false); // Stop spinner
  }
};

  useEffect(() => {
    const fetchCurrentUser = async () => {
      try {
        const token = localStorage.getItem("authToken");
        if (!token) {
          toast.error("No token found. Please log in.");
          setLoading(false);
          return;
        }
        const response = await axios.get(`${BACKEND_BASE_URL}/api/admin-user/current_user/`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setUser(response.data);
      } catch (error) {
        toast.error("Failed to fetch current user info");
        console.error(error);
        setLoading(false);
      }
    };
    fetchCurrentUser();
  }, []);

  useEffect(() => {
    if (!user) return;
    const fetchToggledTowns = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const response = await axios.get(`${BACKEND_BASE_URL}/api/capture/capture-municipalities/`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setToggledTowns(response.data.data || []);
      } catch (error) {
        toast.error("Failed to fetch toggled towns.");
        console.error(error);
      } finally {
        setLoading(false); // ✅ Stop loading when API finishes
      }
    };
    fetchToggledTowns();
  }, [user]);

  const handlePropertiesClick = (event, town) => {
    setAnchorEl(event.currentTarget);
    setSelectedTown(town);
  };

  const handlePropertiesClose = () => {
    setAnchorEl(null);
    setSelectedTown(null);
  };

  return (
    <div style={{ padding: 24, background: "#f7f8fc" }}>
      <Typography variant="h4" style={{ fontWeight: 600, marginTop: 24, marginBottom: 4 }}>
        Manage Town
      </Typography>

      {loading ? (
        // ✅ Show spinner while loading
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
          <CircularProgress style={{ color: "#152F8F" }} />
        </Box>
      ) : (
        <>
          <Typography variant="subtitle1" style={{ marginBottom: 20 }}>
            Total Live Cities: {toggledTowns.length}
          </Typography>

          {toggledTowns.length === 0 ? (
            // ✅ Show message if no towns available
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="120px">
              <Typography variant="body1" color="textSecondary">
                No towns found.
              </Typography>
            </Box>
          ) : (
            <TableContainer
              component={Paper}
              style={{ boxShadow: "0 1px 3px rgba(0,0,0,0.08)", borderRadius: 12 }}
            >
              <Table style={{ tableLayout: "auto" }} size="small">
                <TableHead>
                  <TableRow>
                    <TableCell style={{ ...headerCellStyle, width: 50 }}>S.No.</TableCell>
                    <TableCell style={headerCellStyle}>State</TableCell>
                    <TableCell style={headerCellStyle}>County</TableCell>
                    <TableCell style={headerCellStyle}>Town</TableCell>
                    <TableCell style={headerCellStyle} align="center">Properties</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {toggledTowns.map((town, index) => (
                    <TableRow key={town.id}>
                      <TableCell style={bodyCellStyle}>{index + 1}</TableCell>
                      <TableCell style={bodyCellStyle}>{town.state}</TableCell>
                      <TableCell style={bodyCellStyle}>{town.county}</TableCell>
                      <TableCell style={bodyCellStyle}>{town.name}</TableCell>
                      <TableCell style={{ ...bodyCellStyle, textAlign: "center" }}>
                        <IconButton
                          aria-label="properties"
                          onClick={e => handlePropertiesClick(e, town)}
                          style={{ color: "#152F8F" }}
                        >
                          <SettingsIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </>
      )}

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handlePropertiesClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MenuItem
          onClick={() => {
            window.location.href = `/app/capture-events?municipalityId=${selectedTown?.id}`;
            handlePropertiesClose();
          }}
        >
          Manage Capture
        </MenuItem>
        <MenuItem
          onClick={() => {
            window.location.href = `/app/manage-meeting?municipalityId=${selectedTown?.id}`;
            handlePropertiesClose();
          }}
        >
          Meeting Setup
        </MenuItem>
      </Menu>
    </div>
  );
};

export default ManageAwareCapture;
